import { useEffect, useState } from 'react';

import { Spinner } from '@chakra-ui/react';

import { isPlainShellPath } from './appShellMode';
import { OverlayLoader } from '../../components/OverlayLoader';

const SPINNER_DELAY_MS = 600;

const stylesheet = {
  overlay:
    'fixed inset-0 z-[1600] flex items-center justify-center bg-semantic-bg-page',
};

export function BootFallback() {
  if (isPlainShellPath(window.location.pathname)) {
    return <OverlayLoader isVisible={true} />;
  }

  return <DelayedBootSpinner />;
}

function DelayedBootSpinner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setShow(true), SPINNER_DELAY_MS);
    return () => clearTimeout(id);
  }, []);

  if (!show) {
    return null;
  }

  return (
    <div className={stylesheet.overlay} aria-hidden="true">
      <Spinner thickness="4px" size="xl" variant="emerald" w="48px" h="48px" />
    </div>
  );
}
